var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('JobTemplate',_vm._b({},'JobTemplate',_vm.attributes,false))
}
var staticRenderFns = []

export { render, staticRenderFns }